<template>
  <div id="app">
    <v-app>
      <router-view/>
    </v-app>
  </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "App",
        computed: {
            ...mapState({
                language: state => state.locale.language
            }),
        },
        created () {
            this.$i18n.locale = this.language
        }
    }
</script>

<style>
#app {
  font-family: 'Kanit', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
}
</style>
